module.exports = __webpack_public_path__ + "img/bg_avatar_male_43.6f8588ff.png";